import React, {useEffect, useState} from 'react'
import cx from 'classnames'
import {AppBar, Button} from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import Badge from '@mui/material/Badge';
import {SearchVoucherPending} from '../Vouchers/SearchVoucher';
import PendingUsers from '../Agencies/PendingUsers';
import {useAuth} from '../../hooks/useAuth';
import {endpoints, useApi} from '../../hooks/use-api';
import {UserTypes} from '../../common/Constants'
import RedeemSummary from './RedeemSummary';
import CognitoUsers from '../Users/CognitoUsers';
import FPL from './fpl';
import Intro from './intro';

const InboxOption = ({ optionText, count, selected, onChange }) => (
    <li className="column is-narrow voucher-status-sel clickable">
        <Badge
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            badgeContent={count}
            color="primary"
        >
            <Button variant='text'  className={cx({ selected: selected })}>
                <span onClick={onChange}>{ optionText }</span>
            </Button>
        </Badge>
    </li>
)

const InboxPage = (props) => {
    const { user } = useAuth();
    const [option, setOption] = useState('none')
    const [ { data, loading, error }, refetch ] = useApi(endpoints.entity.user.inbox(), {useCache: false})
    {/* Commented as per March Enhancement */ }
    // useEffect(() => setOption(user.userType === UserTypes.neweyes ? 'summary' : 'voucher'), [user])
    {/* inserted as per March Enhancement */ }
       useEffect(()=> setOption('voucher'),[user])

    if (!user) {
        return <React.Fragment>&nbsp;</React.Fragment>
    }

    return <>
    { data &&
        <>
            <AppBar position="static" color="inherit" elevation={0}>
                <div className="voucherFilter">
                    <Grid2 container justifyContent='center'>
                        <ul className={cx("result-filters")}>
                            <InboxOption optionText={"Info"} onChange={() => setOption("intro")}  />
                            <InboxOption optionText={ user.userType === 1 ? "Pending Approval" : "Approved Voucher" } count={data.vouchers} selected={option === "voucher"} onChange={() => setOption("voucher")} />
                            <InboxOption optionText="pending payment" selected={option === "payment"} count={data.payments} onChange={() => setOption("payment")} />
                            {user.userType !== 3 &&
                                <InboxOption optionText="Pending Users" selected={option === "user"} count={data.users} onChange={() => setOption("user")} /> }
                            {user.userType === UserTypes.neweyes &&
                                <>
                                    <InboxOption optionText="Reset Password" selected={option === "cognito"} onChange={() => setOption("cognito")} />
                                    <InboxOption optionText="FPL" selected={option === "fpl"} onChange={() => setOption("fpl")} />
                                </> }
                        </ul>
                    </Grid2>
                </div>
            </AppBar>
            {option === "intro" && <Intro /> }
            {option === "voucher" && <SearchVoucherPending reload={refetch} /> }
        {option === "payment" && <SearchVoucherPending reload={refetch} url={endpoints.entity.voucher.pending_fee()} />}
            {option === "user" && <PendingUsers reload={refetch} agencyId={user.agency.id} /> }
            {option === "cognito" && <CognitoUsers /> }
            {option === "fpl" && <FPL /> }
        </>
    }
    </>;
}

export default InboxPage;


